module.exports = __webpack_public_path__ + "static/media/ReconhecimentoBacharel.becb8aab.JPG";